import "core-js/modules/es.array.concat.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "agenda-list-page"
  }, [_c('div', {
    staticClass: "agenda-toolbar"
  }, [_c('FilterFields', {
    attrs: {
      "fields": _vm.filterFields
    }
  }), _c('div', {
    staticClass: "agenda-toolbar-actions"
  }, [_c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.bottom",
      value: 'Hoje',
      expression: "'Hoje'",
      modifiers: {
        "hover": true,
        "bottom": true
      }
    }],
    staticClass: "btn btn-light agenda-action-button",
    on: {
      "click": _vm.filtrarHoje
    }
  }, [_c('CalendarToday', {
    attrs: {
      "size": 20
    }
  })], 1), _c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.bottom",
      value: 'Bloqueio de agenda',
      expression: "'Bloqueio de agenda'",
      modifiers: {
        "hover": true,
        "bottom": true
      }
    }],
    staticClass: "btn btn-light agenda-action-button",
    on: {
      "click": _vm.openBloqueioModal
    }
  }, [_c('CalendarLock', {
    attrs: {
      "size": 20
    }
  })], 1), _c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.bottom",
      value: 'Configurações',
      expression: "'Configurações'",
      modifiers: {
        "hover": true,
        "bottom": true
      }
    }],
    staticClass: "btn btn-light agenda-action-button",
    on: {
      "click": _vm.openConfiguracaoModal
    }
  }, [_c('Cog', {
    attrs: {
      "size": 20
    }
  })], 1), _c('button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover.bottom",
      value: 'Gerar link',
      expression: "'Gerar link'",
      modifiers: {
        "hover": true,
        "bottom": true
      }
    }],
    staticClass: "btn btn-light agenda-action-button",
    on: {
      "click": _vm.openLinkModal
    }
  }, [_c('LinkVariant', {
    attrs: {
      "size": 20
    }
  })], 1)])], 1), _c('div', {
    staticClass: "card card-custom card-stretch gutter-b"
  }, [_c('div', {
    staticClass: "card-header border-0 py-5"
  }, [_vm._m(0), _c('div', {
    staticClass: "card-toolbar"
  }, [_c('router-link', {
    staticClass: "btn btn-light-primary font-weight-bolder font-size-sm mr-2",
    attrs: {
      "to": {
        name: 'crmAgendaVisual'
      }
    }
  }, [_c('CalendarCheck', {
    staticClass: "mr-1",
    attrs: {
      "size": 18
    }
  }), _vm._v(" Ver agendamentos ")], 1), _c('router-link', {
    staticClass: "btn btn-dark font-weight-bolder font-size-sm",
    attrs: {
      "to": {
        name: 'crmAgendaNovo'
      }
    }
  }, [_vm._v(" Novo Agendamento ")]), _c('button', {
    staticClass: "btn btn-dark font-weight-bolder font-size-sm ml-2",
    on: {
      "click": _vm.printData
    }
  }, [_c('Printer', {
    attrs: {
      "size": 18
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "card-body pt-0 pb-3"
  }, [_vm.loadingList ? _c('div', {
    staticClass: "agenda-local-loading"
  }, [_c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }), _vm._v(" Carregando agendamentos... ")], 1) : _vm.listError ? _c('div', {
    staticClass: "alert alert-light-danger"
  }, [_c('div', {
    staticClass: "d-flex align-items-center justify-content-between"
  }, [_c('span', [_vm._v(_vm._s(_vm.listError))]), _c('button', {
    staticClass: "btn btn-sm btn-light-danger font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.loadAgendamentos
    }
  }, [_vm._v(" Tentar novamente ")])])]) : _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped agenda-table"
  }, [_c('thead', [_c('tr', _vm._l(_vm.fields, function (field) {
    return _c('th', {
      key: field.field,
      style: {
        width: field.width
      }
    }, [field.sortable ? _c('button', {
      staticClass: "agenda-sort-button",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.sortBy(field.field);
        }
      }
    }, [_vm._v(" " + _vm._s(field.label) + " "), _c('span', [_vm._v(_vm._s(_vm.sortIcon(field.field)))])]) : _c('span', [_vm._v(_vm._s(field.label))])]);
  }), 0)]), _c('tbody', [_vm.agendamentos.length === 0 ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted py-10",
    attrs: {
      "colspan": _vm.fields.length
    }
  }, [_vm._v(" Nenhum registro encontrado ")])]) : _vm._e(), _vm._l(_vm.agendamentos, function (agendamento) {
    return _c('tr', {
      key: agendamento.chave_agendamento || agendamento.id_agendamento
    }, [_c('td', [_c('strong', [_vm._v(_vm._s(_vm.formatDateTime(agendamento.data_inicio)))]), _c('small', {
      staticClass: "text-muted d-block"
    }, [_vm._v(" " + _vm._s(_vm.formatTime(agendamento.data_inicio)) + " - " + _vm._s(_vm.formatTime(agendamento.data_fim)) + " ")])]), _c('td', [_c('strong', [_vm._v(_vm._s(agendamento.cliente || "-"))]), agendamento.titulo ? _c('small', {
      staticClass: "text-muted d-block"
    }, [_vm._v(" " + _vm._s(agendamento.titulo) + " ")]) : _vm._e()]), _c('td', [_vm._v(_vm._s(_vm.responsavelLabel(agendamento)))]), _c('td', [_vm._v(_vm._s(agendamento.duracao_minutos) + " min")]), _c('td', [_c('span', {
      class: _vm.statusClass(agendamento.status)
    }, [_vm._v(" " + _vm._s(_vm.statusLabel(agendamento.status)) + " ")]), _c('span', {
      staticClass: "agenda-origin-badge",
      class: _vm.origemAgendamentoClass(agendamento)
    }, [_vm._v(" " + _vm._s(_vm.origemAgendamentoLabel(agendamento)) + " ")]), agendamento.reagendado ? _c('span', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.bottom",
        value: _vm.reagendamentoTooltip(agendamento),
        expression: "reagendamentoTooltip(agendamento)",
        modifiers: {
          "hover": true,
          "bottom": true
        }
      }],
      staticClass: "agenda-reschedule-badge"
    }, [_vm._v(" R ")]) : _vm._e()]), _c('td', [_c('div', {
      staticClass: "action-buttons"
    }, [_vm.isAgendamentoOperacional(agendamento) ? _c('router-link', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.bottom",
        value: 'Editar',
        expression: "'Editar'",
        modifiers: {
          "hover": true,
          "bottom": true
        }
      }],
      staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2",
      attrs: {
        "to": {
          name: 'crmAgendaEditar',
          params: {
            id: agendamento.id_agendamento
          }
        }
      }
    }, [_c('Pencil', {
      attrs: {
        "size": 16
      }
    })], 1) : _vm._e(), _vm.mostrarMenuAcoes(agendamento) ? _c('b-dropdown', {
      staticClass: "agenda-action-dropdown",
      attrs: {
        "variant": "light-primary",
        "size": "sm",
        "right": "",
        "no-caret": "",
        "boundary": "window",
        "toggle-class": "btn-icon agenda-action-dropdown-toggle"
      },
      scopedSlots: _vm._u([{
        key: "button-content",
        fn: function fn() {
          return [_c('DotsVertical', {
            attrs: {
              "size": 16
            }
          })];
        },
        proxy: true
      }], null, true)
    }, [_vm.canConfirmarAgendamento(agendamento) ? _c('b-dropdown-item', {
      on: {
        "click": function click($event) {
          return _vm.confirmarAgendamento(agendamento);
        }
      }
    }, [_vm._v(" Confirmar ")]) : _vm._e(), _vm.podeReagendarAgenda(agendamento) ? _c('b-dropdown-item', {
      on: {
        "click": function click($event) {
          return _vm.reagendarAgendamento(agendamento);
        }
      }
    }, [_vm._v(" Reagendar ")]) : _vm._e(), _c('b-dropdown-divider'), _vm.podeCancelarAgenda(agendamento) ? _c('b-dropdown-item', {
      staticClass: "text-danger",
      on: {
        "click": function click($event) {
          return _vm.cancelarAgendamento(agendamento);
        }
      }
    }, [_vm._v(" Cancelar ")]) : _vm._e()], 1) : _vm._e(), _vm.podeConcluirAgenda(agendamento) ? _c('button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.bottom",
        value: 'Concluir',
        expression: "'Concluir'",
        modifiers: {
          "hover": true,
          "bottom": true
        }
      }],
      staticClass: "btn btn-sm btn-success btn-icon mr-2",
      on: {
        "click": function click($event) {
          return _vm.alterarStatus(agendamento, 'concluido');
        }
      }
    }, [_c('CheckCircle', {
      attrs: {
        "size": 16
      }
    })], 1) : _vm._e(), _c('button', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.bottom",
        value: 'Enviar resumo por WhatsApp',
        expression: "'Enviar resumo por WhatsApp'",
        modifiers: {
          "hover": true,
          "bottom": true
        }
      }],
      staticClass: "btn btn-sm btn-success btn-icon mr-2",
      on: {
        "click": function click($event) {
          return _vm.shareToWhatsapp(agendamento);
        }
      }
    }, [_c('Whatsapp', {
      attrs: {
        "size": 16
      }
    })], 1)], 1)])]);
  })], 2)]), _c('div', {
    staticClass: "agenda-pagination"
  }, [_c('b-form-select', {
    staticClass: "agenda-per-page",
    attrs: {
      "options": _vm.perPageOptions
    },
    on: {
      "input": _vm.changePerPage
    },
    model: {
      value: _vm.perPage,
      callback: function callback($$v) {
        _vm.perPage = $$v;
      },
      expression: "perPage"
    }
  }), _c('div', {
    staticClass: "agenda-pagination-actions"
  }, [_c('button', {
    staticClass: "btn btn-light font-weight-bold mr-2",
    attrs: {
      "type": "button",
      "disabled": _vm.page <= 1
    },
    on: {
      "click": function click($event) {
        return _vm.changePage(_vm.page - 1);
      }
    }
  }, [_vm._v(" Voltar ")]), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v(" Página " + _vm._s(_vm.page) + " de " + _vm._s(_vm.lastPage) + " ")]), _c('button', {
    staticClass: "btn btn-light font-weight-bold ml-2",
    attrs: {
      "type": "button",
      "disabled": _vm.page >= _vm.lastPage
    },
    on: {
      "click": function click($event) {
        return _vm.changePage(_vm.page + 1);
      }
    }
  }, [_vm._v(" Próximo ")])])], 1)])])]), _c('b-modal', {
    attrs: {
      "id": "agendamentoListaBloqueioModal",
      "centered": "",
      "title": "Bloqueio de agenda",
      "ok-title": "Bloquear",
      "cancel-title": "Cancelar"
    },
    on: {
      "ok": _vm.salvarBloqueio
    }
  }, [_vm.currentUser.admin ? _c('b-form-group', {
    attrs: {
      "label": "Usuário"
    }
  }, [_c('VueSelect', {
    attrs: {
      "label": "nome",
      "filterable": false,
      "options": _vm.usuarios,
      "clearSearchOnSelect": true
    },
    on: {
      "search": _vm.onSearchUsuario
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_vm._v(" " + _vm._s(_vm.usuarioLabel(option)) + " ")];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_vm._v(" " + _vm._s(_vm.usuarioLabel(option)) + " ")];
      }
    }], null, false, 183920173),
    model: {
      value: _vm.usuarioAgenda,
      callback: function callback($$v) {
        _vm.usuarioAgenda = $$v;
      },
      expression: "usuarioAgenda"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v("Informe o nome do usuário")])], 2)], 1) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label": "Início"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "datetime-local"
    },
    model: {
      value: _vm.bloqueioForm.data_inicio,
      callback: function callback($$v) {
        _vm.$set(_vm.bloqueioForm, "data_inicio", $$v);
      },
      expression: "bloqueioForm.data_inicio"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Fim"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "datetime-local"
    },
    model: {
      value: _vm.bloqueioForm.data_fim,
      callback: function callback($$v) {
        _vm.$set(_vm.bloqueioForm, "data_fim", $$v);
      },
      expression: "bloqueioForm.data_fim"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Motivo"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "rows": "3"
    },
    model: {
      value: _vm.bloqueioForm.motivo,
      callback: function callback($$v) {
        _vm.$set(_vm.bloqueioForm, "motivo", $$v);
      },
      expression: "bloqueioForm.motivo"
    }
  })], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "agendamentoListaConfiguracaoModal",
      "centered": "",
      "size": "lg",
      "title": "Configurações da agenda",
      "ok-title": "Salvar",
      "cancel-title": "Cancelar"
    },
    on: {
      "ok": _vm.salvarConfiguracao
    }
  }, [_vm.currentUser.admin ? _c('b-form-group', {
    attrs: {
      "label": "Usuário"
    }
  }, [_c('VueSelect', {
    attrs: {
      "label": "nome",
      "filterable": false,
      "options": _vm.usuarios,
      "clearSearchOnSelect": true
    },
    on: {
      "input": _vm.openConfiguracaoModal,
      "search": _vm.onSearchUsuario
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_vm._v(" " + _vm._s(_vm.usuarioLabel(option)) + " ")];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_vm._v(" " + _vm._s(_vm.usuarioLabel(option)) + " ")];
      }
    }], null, false, 183920173),
    model: {
      value: _vm.usuarioAgenda,
      callback: function callback($$v) {
        _vm.usuarioAgenda = $$v;
      },
      expression: "usuarioAgenda"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v("Informe o nome do usuário")])], 2)], 1) : _vm._e(), _vm._l(_vm.diasSemana, function (dia) {
    return _c('div', {
      key: dia.key,
      staticClass: "agenda-config-day"
    }, [_c('div', {
      staticClass: "agenda-config-day-header"
    }, [_c('strong', [_vm._v(_vm._s(dia.label))]), _c('button', {
      staticClass: "btn btn-sm btn-light-primary font-weight-bold",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.addExpedienteBloco(dia.key);
        }
      }
    }, [_vm._v(" Adicionar ")])]), _vm._l(_vm.configForm.expedientes[dia.key], function (bloco, index) {
      return _c('div', {
        key: "".concat(dia.key, "-").concat(index),
        staticClass: "agenda-config-block"
      }, [_c('b-form-input', {
        attrs: {
          "type": "time"
        },
        model: {
          value: bloco.inicio,
          callback: function callback($$v) {
            _vm.$set(bloco, "inicio", $$v);
          },
          expression: "bloco.inicio"
        }
      }), _c('b-form-input', {
        attrs: {
          "type": "time"
        },
        model: {
          value: bloco.fim,
          callback: function callback($$v) {
            _vm.$set(bloco, "fim", $$v);
          },
          expression: "bloco.fim"
        }
      }), _c('button', {
        staticClass: "btn btn-sm btn-light-danger font-weight-bold",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function click($event) {
            return _vm.removeExpedienteBloco(dia.key, index);
          }
        }
      }, [_vm._v(" Remover ")])], 1);
    }), _vm.configForm.expedientes[dia.key].length === 0 ? _c('small', {
      staticClass: "text-muted"
    }, [_vm._v(" Sem expediente ")]) : _vm._e()], 2);
  })], 2), _c('b-modal', {
    attrs: {
      "id": "agendamentoListaLinkModal",
      "centered": "",
      "size": "lg",
      "title": "Gerar link de agenda",
      "ok-title": "Gerar link",
      "cancel-title": "Cancelar"
    },
    on: {
      "ok": _vm.gerarLinkAgenda
    }
  }, [_vm.currentUser.admin ? _c('b-form-group', {
    attrs: {
      "label": "Usuário"
    }
  }, [_c('VueSelect', {
    attrs: {
      "label": "nome",
      "filterable": false,
      "options": _vm.usuarios,
      "clearSearchOnSelect": true
    },
    on: {
      "search": _vm.onSearchUsuario
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_vm._v(" " + _vm._s(_vm.usuarioLabel(option)) + " ")];
      }
    }, {
      key: "selected-option",
      fn: function fn(option) {
        return [_vm._v(" " + _vm._s(_vm.usuarioLabel(option)) + " ")];
      }
    }], null, false, 183920173),
    model: {
      value: _vm.usuarioAgenda,
      callback: function callback($$v) {
        _vm.usuarioAgenda = $$v;
      },
      expression: "usuarioAgenda"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v("Informe o nome do usuário")])], 2)], 1) : _vm._e(), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Cliente"
    }
  }, [_c('VueSelect', {
    attrs: {
      "label": "nome",
      "filterable": false,
      "options": _vm.clientes,
      "clearSearchOnSelect": true
    },
    on: {
      "search": _vm.onSearchCliente
    },
    model: {
      value: _vm.linkForm.cliente,
      callback: function callback($$v) {
        _vm.$set(_vm.linkForm, "cliente", $$v);
      },
      expression: "linkForm.cliente"
    }
  }, [_c('template', {
    slot: "no-options"
  }, [_vm._v("Informe o nome do cliente")])], 2), _c('button', {
    staticClass: "btn btn-light-primary btn-sm font-weight-bold mt-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openNovoClienteLinkModal
    }
  }, [_vm._v(" Novo Cliente ")])], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data inicial"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.linkForm.data_inicio,
      callback: function callback($$v) {
        _vm.$set(_vm.linkForm, "data_inicio", $$v);
      },
      expression: "linkForm.data_inicio"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data final"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "date"
    },
    model: {
      value: _vm.linkForm.data_fim,
      callback: function callback($$v) {
        _vm.$set(_vm.linkForm, "data_fim", $$v);
      },
      expression: "linkForm.data_fim"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Duração"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "1",
      "max": "1440"
    },
    model: {
      value: _vm.linkForm.duracao_minutos,
      callback: function callback($$v) {
        _vm.$set(_vm.linkForm, "duracao_minutos", _vm._n($$v));
      },
      expression: "linkForm.duracao_minutos"
    }
  })], 1)], 1)], 1), _vm.linkGerado ? _c('div', {
    staticClass: "alert alert-light-success agenda-link-success mb-0"
  }, [_c('strong', [_vm._v("Link gerado com sucesso.")]), _c('button', {
    staticClass: "btn btn-light-primary btn-sm font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.copiarLinkGerado
    }
  }, [_c('ContentCopy', {
    staticClass: "mr-1",
    attrs: {
      "size": 16
    }
  }), _vm._v(" Copiar link ")], 1)]) : _vm._e()], 1), _c('b-modal', {
    attrs: {
      "id": "novoClienteAgendamentoLinkModal",
      "centered": "",
      "size": "xl",
      "title": "Novo Cliente",
      "hide-footer": "",
      "body-class": "p-0 novo-cliente-agendamento-modal-body"
    },
    on: {
      "hidden": _vm.resetNovoClienteLinkModal
    }
  }, [_c('PessoaForm', {
    attrs: {
      "url": "/pessoa/create",
      "pessoa": _vm.novaPessoa,
      "hide-tipo-pessoa": true,
      "force-cliente": true,
      "redirect-on-save": false
    },
    on: {
      "saved": _vm.handleNovoClienteLinkSaved,
      "cancel": function cancel($event) {
        return _vm.$bvModal.hide('novoClienteAgendamentoLinkModal');
      }
    }
  })], 1), _c('b-modal', {
    attrs: {
      "id": "agendaListaReagendarModal",
      "centered": "",
      "title": "Reagendar agendamento",
      "ok-title": "Reagendar",
      "cancel-title": "Cancelar"
    },
    on: {
      "ok": _vm.confirmarReagendamentoAgenda
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nova data e horário"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "datetime-local"
    },
    model: {
      value: _vm.reagendamentoForm.data_inicio,
      callback: function callback($$v) {
        _vm.$set(_vm.reagendamentoForm, "data_inicio", $$v);
      },
      expression: "reagendamentoForm.data_inicio"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Duração em minutos"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "1",
      "max": "1440"
    },
    model: {
      value: _vm.reagendamentoForm.duracao_minutos,
      callback: function callback($$v) {
        _vm.$set(_vm.reagendamentoForm, "duracao_minutos", _vm._n($$v));
      },
      expression: "reagendamentoForm.duracao_minutos"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "Motivo do reagendamento"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "maxlength": "500",
      "rows": "3"
    },
    model: {
      value: _vm.reagendamentoForm.motivo_reagendamento,
      callback: function callback($$v) {
        _vm.$set(_vm.reagendamentoForm, "motivo_reagendamento", $$v);
      },
      expression: "reagendamentoForm.motivo_reagendamento"
    }
  })], 1)], 1), _c('SendToWppModal', {
    attrs: {
      "data": _vm.dataToWhatsapp,
      "openModal": _vm.wppOpenModal,
      "module": "agendamentos"
    },
    on: {
      "handleOpenModal": function handleOpenModal(openModal) {
        return _vm.wppOpenModal = openModal;
      }
    }
  })], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('h3', {
    staticClass: "card-title align-items-start flex-column"
  }, [_c('span', {
    staticClass: "card-label font-weight-bolder text-dark"
  }, [_vm._v(" Agendamentos ")])]);
}];
export { render, staticRenderFns };